// extracted by mini-css-extract-plugin
export var container = "FooterBlockItem-module--container--83552";
export var content = "FooterBlockItem-module--content--b21a2";
export var contentContainer = "FooterBlockItem-module--contentContainer--8c3b3";
export var cta = "FooterBlockItem-module--cta--46283";
export var headline = "FooterBlockItem-module--headline--48b8c";
export var input = "FooterBlockItem-module--input--0e212";